import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router, Route } from '@angular/router';
import { Observable } from 'rxjs';
import { LoginComponent } from '../components/login/login.component';
import { AuthorizationService } from './authorization.service';
import { HomeComponent } from '../components/home/home.component';
import { Right } from '../classes/Right';

@Injectable({
  providedIn: 'root'
})
export class RoutingGuardService implements CanActivate {

  constructor(private router: Router, private authorizationService: AuthorizationService) { }

  canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
    let goingTo: string = state.url;
    if (goingTo.indexOf("?") !== -1) {//incase the url has query parameters
      goingTo = goingTo.substring(0, goingTo.indexOf("?"));
    }
    let user = this.authorizationService.getUser();
    if (user) {
      if (next.data.right && !user.Privileges.includes(next.data.right)) {
        //no privilege to visit page
        return false;
      }
      if (next.component == HomeComponent) {
        if (user.Privileges.includes(Right.SSO)) {
          this.router.navigate(["/config"]);
        }
      }
      if (next.component === LoginComponent) {
        this.router.navigate(["/"]);
      }
    } else {
      if (next.data.requireUser || next.data.right) {
        this.router.navigate(["/login"]);
      }
    }

    return true;
  }

}
